import { MobileHomepage } from 'features/installPwa';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import HotBannerCard from 'shared/components/card-views/HotBannerCard';
import HotLiveBannerCard from 'shared/components/card-views/HotLiveBannerCard';
import { HotBannerData } from 'shared/types/cms';

interface Props extends WithTranslation {
	hotBannerData: HotBannerData[];
	isLiveBanners?: any;
}

const HotBanner: React.FC<Props> = (props) => {
	return (
		<>
			{props.hotBannerData && !isEmpty(props.hotBannerData) && (
				<>
					{props.hotBannerData.map((banner: HotBannerData, key: number) => (
						<section key={banner.bannerId} className="HotBanner">
							{props.isLiveBanners ? <HotLiveBannerCard data={banner} /> : <HotBannerCard data={banner} />}
							{key === 0 && <MobileHomepage forceUpdate={''} />}
						</section>
					))}
				</>
			)}
		</>
	);
};

export default withTranslation()(HotBanner);
